/**
 * @generated SignedSource<<0959916a848ea46909d3b2c110c1d899>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useClubHasPackages_club$data = {
  readonly packages: {
    readonly count: number;
  } | null | undefined;
  readonly supportsPublic: boolean;
  readonly " $fragmentType": "useClubHasPackages_club";
};
export type useClubHasPackages_club$key = {
  readonly " $data"?: useClubHasPackages_club$data;
  readonly " $fragmentSpreads": FragmentRefs<"useClubHasPackages_club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useClubHasPackages_club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsPublic",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "packageType",
          "value": "STANDARD"
        },
        {
          "kind": "Literal",
          "name": "saleAvailability",
          "value": "PUBLIC"
        }
      ],
      "concreteType": "PackageConnection",
      "kind": "LinkedField",
      "name": "packages",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": "packages(packageType:\"STANDARD\",saleAvailability:\"PUBLIC\")"
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "d5c988669b77fc1ef18d3b37d020be88";

export default node;
